import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Calendar } from 'lucide-react';
const week1 = [{
  day: 1,
  text: 'Eliminar toda crítica o queja. Cero conflicto.'
}, {
  day: 2,
  text: 'Ejecutar el Radio Silencio Estratégico.'
}, {
  day: 3,
  text: 'Enfocarte en un hobby o actividad personal fuera de casa.'
}, {
  day: 4,
  text: 'Primera micro-validación honesta.'
}, {
  day: 5,
  text: 'Observación activa: anota 3 disparadores de discusión y evítalos.'
}, {
  day: 6,
  text: 'Autocuidado físico: vístete para ti, no para ellos.'
}, {
  day: 7,
  text: 'Revisión de la semana — Métrica: ¿Cuántas discusiones evitaste?'
}];
export function ThirtyDayPlan() {
  return <section className="py-24 px-6" data-id="element-121">
      <div className="max-w-5xl mx-auto" data-id="element-122">
        <div className="text-center mb-16" data-id="element-123">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-124">
            Tu Plan de Acción de 30 Días
          </h2>
          <p className="text-lg text-charcoal-light" data-id="element-125">
            El mapa exacto para mantener el impulso después de las primeras 72
            horas.
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-8" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="md:col-span-3 bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-navy/5" data-id="element-127">
            <h3 className="text-2xl font-serif text-navy mb-8 flex items-center gap-3" data-id="element-128">
              <Calendar className="w-6 h-6 text-gold" data-id="element-129" />
              Semana 1: Descompresión y Espacio
            </h3>

            <ul className="space-y-5" data-id="element-130">
              {week1.map((item, i) => <motion.li key={item.day} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.1
            }} className="flex items-start gap-4" data-id="element-131">
                  <div className="mt-0.5 shrink-0" data-id="element-132">
                    <CheckCircle className="w-5 h-5 text-gold/80" strokeWidth={1.5} data-id="element-133" />
                  </div>
                  <div data-id="element-134">
                    <span className="font-medium text-navy mr-2" data-id="element-135">
                      Día {item.day}:
                    </span>
                    <span className="text-charcoal-light" data-id="element-136">{item.text}</span>
                  </div>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="md:col-span-2 flex flex-col gap-6" data-id="element-137">
            <div className="bg-navy text-cream rounded-2xl p-8 md:p-10 shadow-lg h-full flex flex-col justify-center" data-id="element-138">
              <h3 className="text-2xl font-serif mb-4 text-gold" data-id="element-139">
                Semana 2: Re-Apertura
              </h3>
              <p className="font-medium text-lg mb-2" data-id="element-140">Días 8-14</p>
              <p className="text-cream/80 leading-relaxed mb-6" data-id="element-141">
                Implementar diálogos de 5 minutos sobre temas no matrimoniales.
                El foco es reconstruir la amistad, no presionar la relación.
              </p>
              <div className="mt-auto pt-6 border-t border-cream/10" data-id="element-142">
                <p className="text-sm text-cream/60 italic" data-id="element-143">
                  * El plan completo de 30 días, incluyendo las semanas 3 y 4 de
                  Consolidación, se detalla en el interior del ebook.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}